import { render } from "./TableSettingsButton.vue?vue&type=template&id=7b9021d9"
import script from "./TableSettingsButton.vue?vue&type=script&lang=js"
export * from "./TableSettingsButton.vue?vue&type=script&lang=js"

import "./TableSettingsButton.vue?vue&type=style&index=0&id=7b9021d9&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__